// Module
var code = "<div> <ng-include ng-if=\"!vm.previewMode\" src=\"'notifications-area-edit.html'\"></ng-include> <ng-include ng-if=\"vm.previewMode\" src=\"'notifications-area-preview.html'\"></ng-include> </div> ";
// Exports
module.exports = code;